import { Stack, StackDirection } from "@chakra-ui/react";
import { ButtonProps } from "src/components/base/button";
import { GoToWikifolioButton } from "src/components/common/buttons/go-to-wikifolio-button/go-to-wikifolio-button";
import { InvestButton } from "src/components/common/buttons/innvest-button/invest-button";
import { IBestsellerWikifolio } from "src/components/modules/bestseller-module/bestseller.types";
import { CopyIsinButton } from "src/components-mui/common/buttons/copy-isin-button/copy-isin-button";
import { WatchlistButton } from "src/components-mui/common/buttons/watchlist-button/watchlist-button";
import { useLinkBuilder } from "src/hooks/use-link-builder";
import { EnumWfActionType } from "src/types/common-enum";

interface ISingleActionButtonProps extends IBestsellerWikifolio {
    actionType: EnumWfActionType;
    isPrimary?: boolean;
    addedToWatchlistMessage?: string;
    removedFromWatchlistMessage?: string;
}
const SingleActionButton = ({
    id: wikifolioId,
    symbol,
    isin,
    wkn,
    shortDescription,
    isLicensed,
    isOnWatchlist,
    actionType,
    isPrimary,
    addedToWatchlistMessage,
    removedFromWatchlistMessage,
}: ISingleActionButtonProps) => {
    const btnProps: ButtonProps = {
        variant: isPrimary ? "outline" : "ghost",
        width: "100%",
        size: "sm",
    };

    const { buildWikifolioLink } = useLinkBuilder();

    switch (actionType) {
        case EnumWfActionType.CopyIsin:
            return <CopyIsinButton {...btnProps} isin={isin} isDisabled={!isLicensed} />;
        case EnumWfActionType.GoToWf:
            return <GoToWikifolioButton {...btnProps} href={buildWikifolioLink(symbol)} />;
        case EnumWfActionType.Watchlist:
            return (
                <WatchlistButton
                    wikifolioId={wikifolioId}
                    wikifolioShortDescription={shortDescription}
                    isOnWatchlist={isOnWatchlist}
                    addedToWatchlistMessage={addedToWatchlistMessage}
                    removedFromWatchlistMessage={removedFromWatchlistMessage}
                    variant={isPrimary ? "outlined" : "ghost"}
                    size="small"
                    sx={{ width: "100%" }}
                />
            );
        case EnumWfActionType.Invest:
            return <InvestButton {...btnProps} {...{ wikifolioId, isin, wkn }} isDisabled={!isLicensed} />;
        default:
            return null;
    }
};

export interface IBestsellerActionButtonsProps extends IBestsellerWikifolio {
    actions: EnumWfActionType[];
    buttonsDirection?: StackDirection;
    addedToWatchlistMessage?: string;
    removedFromWatchlistMessage?: string;
}

export const BestsellerActionButtons = ({ buttonsDirection, actions, ...wfData }: IBestsellerActionButtonsProps) => (
    <Stack direction={buttonsDirection} spacing={2}>
        <SingleActionButton actionType={actions[0]} {...wfData} isPrimary />
        <SingleActionButton actionType={actions[1]} {...wfData} />
    </Stack>
);
